<template>
  <!-- 首页 -->
  <div class="bannerBottomContent">
    <!-- <div class="main_left" :style="{backgroundImage:`url(${require('@/assets/home/bannerbottom/no3.png')})`}">
          <dl>
              <dt>果实版权文章库</dt>
          </dl>
    </div>-->
    <el-carousel
      :interval="8000"
      arrow="always"
      indicator-position="none"
      autoplay
      height="400px"
    >
      <el-carousel-item v-for="(items, indexs) in listbig" :key="indexs">
        <div class="main_right">
          <dl
            v-for="(item, index) in items.list"
            :key="index"
            :style="{ backgroundImage: `url(${item.img})` }"
            @click="lookChannelList(item)"
          >
            <dt>{{ item.title }}</dt>
            <dd>查看</dd>
            <!-- <dd>
              查看更多
              <img src="@/assets/home/bannerbottom/righticon.png" alt />
            </dd>-->
            <!-- <button class="button_simple" @click="lookChannelList(item)">查看</button> -->
          </dl>
          <dl style="width: 322px; height: 0"></dl>
        </div>
      </el-carousel-item>
    </el-carousel>
    <!-- <div class="main_right">
      <dl
        v-for="(item,index) in list"
        :key="index"
        :style="{backgroundImage:`url(${item.img})`}"
        @click="lookChannelList(item)"
      >
        <dt>{{item.title}}</dt>
        <dd>
          查看更多
          <img src="@/assets/home/bannerbottom/righticon.png" alt />
        </dd>
      </dl>
    </div>-->
  </div>
</template>

<script>
export default {
  name: "home",
  data() {
    return {
      listbig: [
        {
          list: [
            {
              state: "40bc7c7845da49ffa9391bb80f9efb03",
              title: "果实时政信息流",
              img: require("@/assets/home/bannerbottom/no1.png"),
              path: "/channelList",
            },
            {
              state: "7616486caac44033989dae410f6d6494",
              title: "果实财经信息流",
              img: require("@/assets/home/bannerbottom/no7.png"),
              path: "/channelList",
            },
            {
              state: "04740082f07c42a7af39f8bb383d734f",
              title: "果实生活信息流",
              img: require("@/assets/home/bannerbottom/no3.png"),
              path: "/channelList",
            },
            {
              state: "8b6ce687a68d421986532e556c7397ef",
              title: "果实人文历史信息流",
              img: require("@/assets/home/bannerbottom/no2.png"),
              path: "/channelList",
            },
            {
              state: "52f9d510f8f2440b8c69d5aad940cae0",
              title: "果实健康信息流",
              img: require("@/assets/home/bannerbottom/no5.png"),
              path: "/channelList",
            },
            {
              state: "cff03be617e4463288e9aae9601b2c56",
              title: "果实教育信息流",
              img: require("@/assets/home/bannerbottom/no6.png"),
              path: "/channelList",
            },
          ],
        },
        {
          list: [
            {
              state: "d0a876c621bc4421a686dfe91880229f",
              title: "果实旅行信息流",
              img: require("@/assets/home/bannerbottom/no4.png"),
              path: "/channelList",
            },
            {
              state: "287c6bc2998946ac824350f8732933d7",
              title: "果实娱乐信息流",
              img: require("@/assets/home/bannerbottom/no8.png"),
              path: "/channelList",
            },
            {
              state: "c3cc2e7063ab4f1c9c193e2f93f1bbee",
              title: "果实三农信息流",
              img: require("@/assets/home/bannerbottom/no9.png"),
              path: "/channelList",
            },
            {
              state: "ba81f542739a40dfadd473fa8a20d8c6",
              title: "果实科技信息流",
              img: require("@/assets/home/bannerbottom/no10.png"),
              path: "/channelList",
            },
            {
              state: "74ae01d740504589a4571a44b2a04edc",
              title: "果实军事信息流",
              img: require("@/assets/home/bannerbottom/no11.png"),
              path: "/channelList",
            },
            {
              state: "0b5a64db6a2342ecbcddc851b30597ab",
              title: "播客精选",
              img: require("@/assets/home/bannerbottom/no7.jpg"),
              path: "/channelList",
            },
          ],
        },
      ],
    };
  },
  methods: {
    lookChannelList(item) {
      this.$router.push({
        path: item.path,
        query: {
          initialState: item.state,
        },
      });
    },
  },
};
</script>
<style>
.el-icon-arrow-left {
  color: #363636;
  font-weight: 1000;
}
.el-icon-arrow-right {
  color: #363636;
  font-weight: 1000;
}
.el-carousel__item h3 {
  font-size: 18px;
  opacity: 0.75;
  line-height: 300px;
  margin: 0;
}
</style>
<style scoped lang="less">
.el-carousel__arrow i {
  color: #333 !important;
}
.bannerBottomContent {
  padding: 40px 0 60px 0;
  // display: flex;
  // justify-content: space-between;
  color: #ffffff;
  // .main_left{
  //     width: 480px;
  //     height: 400px;
  //     background-size: cover;
  //     background-color:#e3e3e3;
  //     display: flex;
  //     border-radius: 6px;
  //     overflow: hidden;
  //     flex-direction: column;
  //     justify-content: center;
  //     dl{
  //         text-align: center;
  //         dt{
  //             font-size: 40px;
  //         }
  //         dd{
  //             font-size: 24px;
  //         }
  //     }
  // }
  .main_right {
    width: 1046px;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    // flex-direction: row;
    dl {
      text-align: center;
      width: 322px;
      height: 180px;
      display: flex;
      background-size: cover;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      border-radius: 6px;
      overflow: hidden;
      cursor: pointer;
      // position: relative;
      background-color: #e3e3e3;
      dt {
        font-size: 24px;
        // line-height: 180px;
        margin: 63px auto 20px;
      }
      dd {
        cursor: pointer;
        width: 60px;
        height: 34px;
        border-radius: 4px;
        border: 2px solid rgba(255, 255, 255, 1);
        text-align: center;
        line-height: 34px;

        // cursor: pointer;
        // width: 200px;
        // font-size: 12px;
        // position: absolute;
        // bottom: 15px;
        // right: 20px;
        // color: #ffffff;
        // display: flex;
        // justify-content: flex-end;
        // align-items: center;
        img {
          height: 12px;
          margin-left: 10px;
        }
      }
      button {
        width: 100px;
        height: 40px;
        // background: rgba(255,255,255,1);
        // border-radius: 6px;
        // font-size:14px;
        // font-weight: 600;
        // color: rgba(21,47,106,1);
        // line-height: 14px;
        // outline: none;
      }
    }
    dl:nth-of-type(odd) {
      // margin-right: 40px;
    }
    dl:nth-child(1) {
      margin-bottom: 40px;
    }
  }
}
.button_simple:hover {
  background: rgba(33, 77, 166, 1);
  border-color: rgba(33, 77, 166, 1);
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/page/home/homeComponents/bannerBottomContent.vue